import { render, staticRenderFns } from "./DialogAnnounceTypeDepartment.vue?vue&type=template&id=2a4033aa&scoped=true&"
import script from "./DialogAnnounceTypeDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceTypeDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceTypeDepartment.vue?vue&type=style&index=0&id=2a4033aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4033aa",
  null
  
)

export default component.exports